<template>
    <v-row>
        <ActionDropdown 
            :items="actions"
            context="Works"
            :alvqa="alvqa"
            cols="2"
        /> 
        <ImportButton
            :items="importOptions"
            context="FileImport"
            cols="2"
            :alvqa="alvqa"
        />
        <v-col 
            cols="4"
            align-self="center"
            class="v-label theme--light mt-3"
        >
            <BaseHeaderStats 
                context="Works" 
                typeStats="LIST"
                :alvqa="alvqa + '-list'"
            />
        </v-col>
        <v-spacer />
        <v-col 
            cols="2" 
            align-self="end" 
            class="text-right"
        >
            <v-menu offset-y>
                <template v-slot:activator="{ on }">
                    <BaseButton
                        label="lang_PUBLISHING_WORKS_CAPTION_NEW_WORK"
                        v-on="on"
                        block
                        color="buttonNewEntity"
                        :alvqa="alvqa + '-list-button-new'"
                    />
                </template>
                <v-list>
                    <v-list-item
                        v-for="(item, index) in addNewWorkItems"
                        :key="index"
                        @click="createNewWork(item)"
                    >
                        <v-list-item-title :alvqa="item.alvqa">{{ item.text }}</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-col>
    </v-row>
</template>

<script>
import ActionDropdown from '@/components/_actions/ActionDropdown'
import ImportButton from '@/components/_buttons/ImportButton'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseButton from '@/components/_buttons/BaseButton'

export default {
    name: "WorksTopSlot",
    components: {
        ActionDropdown,
        ImportButton,
        BaseHeaderStats,
        BaseButton
    },
    data() {
        return {
            alvqa: "publishing-works"
        }
    },
    computed: {	
		actions() {
			return [
                {
                    text: this.$t('lang_GENERIC_CAPTION_EXPORT'), 
                    value: 'exportWorks',
                    alvqa: this.alvqa + '-list-action-dropdown-export-all'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_COPY'), 
                    value: 'copy',
                    alvqa: this.alvqa + '-list-action-dropdown-copy'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_OPTION_TEST_CALCULATION_C3'), 
                    value: 'testCalculationC3',
                    alvqa: this.alvqa + '-list-action-dropdown-test-calculation-c3'
                }, 
				{
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_OPTION_ADD_CONTRACT'), 
                    value: 'addContract',
                    alvqa: this.alvqa + '-list-action-dropdown-add-contract'
                },
                {
                    text: this.$t('lang_ACCOUNT_CREDENTIALS_TYPE_OPTION_GEMA_SOUNDFILE_API'), 
                    value: 'gemaSoundfile',
                    alvqa: this.alvqa + '-list-action-dropdown-gema-soundfile'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_MANAGE_TAGS'), 
                    value: 'replaceTags',
                    alvqa: this.alvqa + '-list-action-dropdown-manage-tags'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_OPTION_WORKS_REGISTRATION'), 
                    value: 'worksRegistration',
                    alvqa: this.alvqa + '-list-action-dropdown-works-registration'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_OPTION_WORKS_BULK_EDITING'), 
                    value: 'worksBulkEditing',
                    alvqa: this.alvqa + '-list-action-dropdown-works-bulk-editing'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_SHARE_DATA'),
                    value: 'dataSharing',
                    alvqa: this.alvqa + '-list-action-dropdown-works-data-sharing'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_ACTION_OPTION_MERGE_WORKS'),
                    value: 'mergeWorks',
                    alvqa: this.alvqa + '-list-action-dropdown-merge-works'
                },
                {
                    text: this.$t('lang_GENERIC_CAPTION_DELETE'), 
                    value: 'delete',
                    alvqa: this.alvqa + '-list-action-dropdown-delete'
                },
			]
        },
        
		importOptions() {
            return [
                {
                    text: this.$t('lang_ACCOUNT_MAPPINGS'),
                    value: 'mappingImport',
                    alvqa: this.alvqa + '-list-import-dropdown-mapping-import'
                },
                {
                    text: this.$t('lang_PUBLISHING_INCOME_BUTTON_OPTION_SUISA'), 
                    value: 'suisaWorks',
                    alvqa: this.alvqa + '-list-import-dropdown-suisa-works'
                },
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_WORKSEXPORT_CAPTION_TYPE_CWR'),
                    value: 'cwr',
                    alvqa: this.alvqa + '-list-import-dropdown-cwr'
                },
            ]
     },
        addNewWorkItems() {
            return [
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_GHOST'), 
                    value: 'ghost',
                    alvqa: this.alvqa + '-list-button-new-dropdown-ghost'
                },
                {
                    text: this.$t('lang_PUBLISHING_WORKS_CAPTION_TO_BE_REGISTERED'), 
                    value: 'toBeRegistered',
                    alvqa: this.alvqa + '-list-button-new-dropdown-to-be-registered'
                }
            ]
        }
    },
    methods: {
        openExportAllWorksDialog() {
            this.$store.commit('setExportAllWorks', true)
            this.$store.commit('setShowExportWorksDialog', true)
        },
        openBulkEditingAllWorksDialog() {
            this.$store.commit('setBulkEditingAllWorks', true)
            this.$store.commit('setShowWorksBulkEditingDialog', true)
            this.$store.dispatch('fetchWorkSubpublishers')
            this.$store.dispatch('doWorksAction')
        },
        createNewWork(item) {
            // Continue with the existing logic to create a new work
            this.$store.commit('setCreateNewWorkStatus', item.value)
            this.$router.push( { name: 'WorksEdit', params: { alvId: 'new'} })
            
            // Translate the item text for the event name
            const itemText = item.value;
            const eventName = `Clicked ${itemText}`;

            // Track the click with Mixpanel
             mixpanel.track(eventName, {
             'Name': item.value,
             'context': this.$route ? this.$route.name : 'unknown', // Make sure $route is available
             'routePath': this.$route.path,
            // Include any additional properties here
            });
        }
    }  
}
</script>   